import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { theme } from 'material-theme';

export interface LcardBadgeProps {
 color?: string;
}

export const LcardBadge: FC<LcardBadgeProps> = ({ color = theme.palette.primary.main }) => (
 <Typography variant='h6' style={{ color }} component='span'>
  L-CARD PRO
 </Typography>
);
